var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"iframe",attrs:{"src":_vm.iframeHref,"scrolling":"no"}})
}
var staticRenderFns = []

export { render, staticRenderFns }